import { Box } from '@mui/material';

import { Header } from 'src/components/Header';

import { AuthArtBackground } from '../components/AuthArtBackground';

export const AuthLayout = ({ children }: { children: React.ReactNode }) => (
  <Box
    sx={(theme) => ({
      minHeight: '100vh',
      backgroundColor: theme.palette.background.chalk,
      position: 'relative',
      overflow: 'hidden',
    })}
  >
    <Header />
    <AuthArtBackground />
    <div style={{ position: 'relative', zIndex: 1 }}>{children}</div>
  </Box>
);
